module.exports = __webpack_public_path__ + "img/1504548352.d355259b.jpg";